<template>
    <div class="order-analyzes">
        <el-row class="order-analyze-title">
            <el-col :span="3">
                <span class="h3">{{ $t('wu_liao_fen_xi') }}</span>
            </el-col>
            <el-col :span="21" class="order-analyze-list-filter">
                <el-form label-width="auto" :inline="true" size="mini">
                    <el-col :span="7">
                        <el-form-item :label="$t('tiao_jian_sou_suo')">
                            <el-select :placeholder="$t('qing_shu_ru_she_bei_ming_cheng')" class="order-input-filter"
                                @change="loadSingleDevicematerialList(deviceUuid)" v-model="pagination.deviceUuid"
                                filterable remote reserve-keyword clearable :remote-method="deviceNameSearch"
                                prefix-icon="el-icon-search">
                                <el-option v-for="item in devices" :key="item.uuid" :label="item.name"
                                    :value="item.uuid">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="10">
                        <el-form-item :label="$t('shi_jian_fan_wei')">
                            <el-date-picker v-model="makeTimeRange" @change="loadmaterialList()" type="daterange"
                                :picker-options="pickerOptions" :range-separator="$t('to')"
                                :start-placeholder="$t('kai_shi_ri_qi')" :end-placeholder="$t('jie_su_ri_qi')">
                            </el-date-picker>

                        </el-form-item>
                    </el-col>

                    <el-col :span="1">
                        <el-button type="primary" size="mini" @click="exportMaterials"> {{ $t('dao_chu') }}
                        </el-button>
                    </el-col>


                </el-form>
            </el-col>
        </el-row>

        <div class="order-analyze-data-list">
            <el-row  :gutter="20">
                <el-col :span="4">
                    <div class="order-analyze-info-item">
                        <span class="h4">{{ $t('ka_fei_dou_shu') }}</span>
                        <div class="analyze-info-result">
                            <p class="info-data"><span class="info-data-number">{{ this.totalCoffeeBean }}</span>
                                {{ $t('ke') }}</p>
                        </div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="order-analyze-info-item">
                        <span class="h4">{{ $t('nai_mo_liang') }}</span>
                        <div class="analyze-info-result">
                            <p class="info-data"><span class="info-data-number">{{ this.totalFoam }}</span>
                                {{ $t('hao_sheng') }}</p>
                        </div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="order-analyze-info-item">
                        <span class="h4">{{ $t('niu_nai_liang') }}</span>
                        <div class="analyze-info-result">
                            <p class="info-data"><span class="info-data-number">{{ this.totalMilk }}</span>
                                {{ $t('hao_sheng') }}</p>
                        </div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="order-analyze-info-item">
                        <span class="h4">{{ $t('nai_gai_liang') }}</span>
                        <div class="analyze-info-result">
                            <p class="info-data"><span class="info-data-number">{{ this.totalMilkCover }}</span>
                                {{ $t('hao_sheng') }}</p>
                        </div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="order-analyze-info-item">
                        <span class="h4">{{$t('fen_liao_ke_zhong')}}</span>
                        <div class="analyze-info-result">
                            <p class="info-data"><span class="info-data-number">{{ this.totalPowder }}</span>
                                {{ $t('ke') }}</p>
                        </div>
                    </div>
                </el-col>

            </el-row>

            <div class="chart-30">
                <p class="item-title">{{ $t('jin_30_tian_wu_liao_xiao_hao') }}</p>
                <div class="chart" id="line30Chart">
                </div>
            </div>
            <!-- <div class="style">
          <pay-style-pie class="top10-chart" ref="payPie"></pay-style-pie>
        </div> -->
            <div class="seg" />
        </div>

    </div>

</template>
  
<script>
import echarts from 'echarts'
import PayStylePie from '@/components/PayStylePie'
import { deviceSearch, deviceCnt } from '@/api/delivery/device/list'
import { materialList,materialExport } from '@/api/delivery/order/material'
import { groupAll } from '@/api/delivery/organization/group'

export default {
    name: '',
    components: {
        PayStylePie
    },
    mounted: function () {
        this.init()
        groupAll().then(res => {
            this.groups = res.data || []
        })
        this.loadmaterialList()

    },
    data: function () {
        return {
            groups: [],
            loading: false,
            pickerOptions: {
                shortcuts: [{
                    text: this.$t('jin_tian'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setHours(0, 0, 0, 0)
                        end.setHours(23, 59, 59, 0)
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: this.$t('zuo_tian'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24);
                        start.setHours(0, 0, 0, 0)
                        end.setTime(end.getTime() - 3600 * 1000 * 24);
                        end.setHours(23, 59, 59, 0)

                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: this.$t('zui_jin_yi_zhou'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: this.$t('zui_jin_yi_yue'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: this.$t('zui_jin_san_yue'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: this.$t('zui_jin_yi_nian'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            makeTimeRange: [],
            line30Option: {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    orient: 'horizontal', // 'vertical'
                    x: 'right', // 'center' | 'left' | {number},
                    y: 'top', // 'center' | 'bottom' | {number}
                    padding: [5, 100, 15, 20],    // [5, 10, 15, 20]
                    itemGap: 20,
                    textStyle: {
                        color: '#BAC3CE',
                    }
                },
                grid: {
                    top: '18%',
                    right: '4%',
                    left: '6%',
                    bottom: '14%',
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#E2E2E2'
                        }
                    },
                    axisLabel: {
                        color: '#E2E2E2'
                    },
                    data: []
                },
                yAxis: [
                    {
                        type: 'value',
                        name: this.$t('shu_liang'),
                        axisLine: {
                            lineStyle: {
                                color: '#E2E2E2'
                            }
                        },
                        axisTick: {
                            show: false,
                        },

                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: '#e2e2e2',
                                type: 'dashed'
                            }
                        },

                        axisLabel: {
                            formatter: '{value}',
                            color: '#E2E2E2',
                        }
                    },
                    {
                        type: 'value',
                        name: '',
                        axisLine: {
                            show: false,
                        },
                        axisTick: {
                            show: false,
                        },
                        nameTextStyle: {
                            color: '#E2E2E2',
                            fontWeight: '600'
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: "#2B3139",
                                type: 'dotted',
                            },
                        },

                        axisLabel: {
                            formatter: '{value}',
                            color: '#E2E2E2',
                        }
                    }
                ],
                series: [
                    {
                        name: this.$t('ka_fei_dou_shu'),
                        type: 'line',
                        smooth: true,
                        lineStyle: {
                            normal: {
                                width: 1
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                    offset: 0,
                                    color: 'rgba(7,44,90,0.3)'
                                }, {
                                    offset: 1,
                                    color: 'rgba(0,212,199,0.9)'
                                }]),
                                shadowColor: 'rgba(0, 0, 0, 0.1)',
                                shadowBlur: 10
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: 'rgb(0,212,199)'

                            }
                        },

                        data: [],

                    },
                    {
                        name: this.$t('niu_nai_liang'),
                        type: 'line',
                        data: [],
                        yAxisIndex: 1,
                        symbolSize: 2,

                        smooth: true,
                        lineStyle: {
                            normal: {
                                width: 1
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                    offset: 0,
                                    color: 'rgba(7,44,90,0.3)'
                                }, {
                                    offset: 1,
                                    color: 'rgba(0,146,246,0.9)'
                                }]),
                                shadowColor: 'rgba(0, 0, 0, 0.1)',
                                shadowBlur: 10

                            }
                        },
                        itemStyle: {
                            normal: {
                                color: 'rgb(0,146,246)'
                            }
                        },
                    },
                    {
                        name: this.$t('nai_mo_liang'),
                        type: 'line',
                        data: [],
                        yAxisIndex: 1,
                        symbolSize: 3,

                        smooth: true,
                        lineStyle: {
                            normal: {
                                width: 1
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                    offset: 0,
                                    color: 'rgba(7,44,90,0.3)'
                                }, {
                                    offset: 1,
                                    color: 'rgba(255,235,205,0.9)'
                                }]),
                                shadowColor: 'rgba(0, 0, 0, 0.1)',
                                shadowBlur: 10

                            }
                        },
                        itemStyle: {
                            normal: {
                                color: 'rgb(255,235,205)'
                            }
                        },
                    },
                    {
                        name: this.$t('nai_gai_liang'),
                        type: 'line',
                        data: [],
                        yAxisIndex: 1,
                        symbolSize: 4,

                        smooth: true,
                        lineStyle: {
                            normal: {
                                width: 1
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                    offset: 0,
                                    color: 'rgba(7,44,90,0.3)'
                                }, {
                                    offset: 1,
                                    color: 'rgba(255,192,203,0.9)'
                                }]),
                                shadowColor: 'rgba(0, 0, 0, 0.1)',
                                shadowBlur: 10

                            }
                        },
                        itemStyle: {
                            normal: {
                                color: 'rgb(255,192,203)'
                            }
                        },
                    },
                    {
                        name: this.$t('fen_liao_ke_zhong'),
                        type: 'line',
                        data: [],
                        yAxisIndex: 1,
                        symbolSize: 5,

                        smooth: true,
                        lineStyle: {
                            normal: {
                                width: 1
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                    offset: 0,
                                    color: 'rgba(7,44,90,0.3)'
                                }, {
                                    offset: 1,
                                    color: 'rgba(189,252,201,0.9)'
                                }]),
                                shadowColor: 'rgba(0, 0, 0, 0.1)',
                                shadowBlur: 10

                            }
                        },
                        itemStyle: {
                            normal: {
                                color: 'rgb(189,255,201)'
                            }
                        },
                    },
                ]
            },
            pagination: {
                startAt: 0,
                endAt: 0,
                groupUuid: '',
                deviceUuid: '',
            },
            devices: [],
            deviceCnt: 0,
            deviceCntKeep: 0,
            myChart: null,
            totalSale: 0,
            totalOrder: 0,
            totalCoffeeBean: 0,
            totalMilk: 0,
            totalFoam: 0,
            totalMilkCover: 0,
            totalPowder:0,
        }
    },
    methods: {
        exportMaterials(){
            let startTs = this.makeTimeRange[0].getTime()
            let startAt = parseInt(startTs / 1000)
            let endTs = this.makeTimeRange[1].getTime()

            materialExport({
                groupUuid: this.pagination.groupUuid,
                deviceUuid: this.pagination.deviceUuid,
                startAt: startAt,
                endAt: parseInt(endTs / 1000),
            }).then(res => {

                var downloadElement = document.createElement('a');
                downloadElement.href = res.data;
                downloadElement.download = (new Date()).Format('yyyyMMddhhmmss')+'.xlsx'; //下载后文件名
                document.body.appendChild(downloadElement);
                downloadElement.click(); //点击下载
                document.body.removeChild(downloadElement); //下载完成移除元素
            })
            console.log(111111)
        },
        handleEdit(row, index) {
        },

        deviceNameSearch(query) {
            if (query !== '') {
                this.loading = true;
                deviceSearch({ name: query }).then(res => {
                    this.devices = res.data || []
                    this.loading = false;
                })
            } else {
                this.devices = [];
            }
        },
        loadSingleDevicematerialList() {
            if (this.pagination.deviceUuid) {
                this.deviceCnt = 1
            } else {
                this.deviceCnt = this.deviceCntKeep
            }


            this.loadmaterialList()

        },
        loadmaterialList() {
            if (this.makeTimeRange.length === 0) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                this.makeTimeRange = [start, end];
            }
            let ts = []

            let startTs = this.makeTimeRange[0].getTime()

            let startAt = parseInt(startTs / 1000)
            let endTs = this.makeTimeRange[1].getTime()
            let oneDay = 3600 * 1000 * 24

            let index = {}
            let coffeeBean = []
            let foam = []
            let milk = []
            let milkCover = []
            let powder =[]

            let i = 0;
            while (true) {
                if (startTs > endTs) {
                    break
                }
                let d = new Date(startTs).Format('yyyy-MM-dd')
                index[d] = i++;
                ts.push(d)
                coffeeBean.push(0)
                foam.push(0)
                milk.push(0)
                milkCover.push(0)
                powder.push(0)

                startTs += oneDay
            }

            let totalCoffeeBean = 0
            let totalMilk = 0
            let totalFoam = 0
            let totalMilkCover = 0
            let totalPowder =0

            materialList({
                groupUuid: this.pagination.groupUuid,
                deviceUuid: this.pagination.deviceUuid,
                startAt: startAt,
                endAt: parseInt(endTs / 1000),
            }).then(res => {
                let saleInfos = res.data || []
                saleInfos.forEach(item => {

                    if (item.month < 10) {
                        item.month = '0' + item.month
                    }
                    if (item.day < 10) {
                        item.day = '0' + item.day
                    }

                    let key = index[`${item.year}-${item.month}-${item.day}`]
                    console.log(key)
                    totalCoffeeBean += item.coffeeBean
                    totalMilk += item.milk
                    totalFoam += item.foam
                    totalMilkCover += item.milkCover
                    totalPowder +=item.powder
                    coffeeBean[key] = item.coffeeBean
                    foam[key] = item.foam
                    milk[key] = item.milk
                    milkCover[key] = item.milkCover
                    powder[key]=item.powder
                })
                this.line30Option.xAxis.data = ts
                this.line30Option.series[0].data = coffeeBean
                this.line30Option.series[1].data = foam
                this.line30Option.series[2].data = milk
                this.line30Option.series[3].data = milkCover
                this.line30Option.series[4].data = powder
                this.myChart.setOption(this.line30Option)
                this.totalCoffeeBean = totalCoffeeBean
                this.totalMilk = totalMilk
                this.totalFoam = totalFoam
                this.totalMilkCover = totalMilkCover
                this.totalPowder=totalPowder
            })
        },
        init() {
            this.myChart = echarts.init(document.getElementById('line30Chart'));
            this.myChart.setOption(this.line30Option)
        }
    },
}
</script>
  
<style lang="scss">
.order-analyzes {
    padding: $padding $t-padding;
    display: flex;
    flex-direction: column;

    .order-analyze-list-filter {
        .el-range-input {
            border: none;
        }

        input {
            border: none;
            border-bottom: 1px solid $f_fiv_color;
            font-size: $filter-font-size;
            border-radius: 0;
        }
    }

    .order-analyze-data-list {
        margin-top: $padding;
        flex: 1;
        .el-col-4{
            width: 20%;
        }

        .order-analyze-info-item {
            border: 1px solid $border_sec_color;
            border-radius: .5rem;
            height: 8rem;
            background-color: $bg_sec_color;
            padding: $padding;
            display: flex;
            flex-direction: column;
            text-align: center;

            .h4 {
                text-align: left;
                font-size: .8rem;
                font-weight: 600;
                display: inline-block;
                margin-bottom: $padding;
                color: $f_sec_color;
            }

            .analyze-info-result {
                flex: 1;
                justify-content: center;
                align-items: center;

                .info-data {
                    margin-bottom: $padding;
                    color: $f_th_color;

                    .info-data-number {
                        font-size: 1.6rem;
                        // font-weight: 600;

                    }

                }

                .info-data-calc {
                    font-size: .6rem;
                    color: $f_sec_color;
                }
            }
        }

        .item-title {
            font-size: .8rem;
            font-weight: 600;
            display: inline-block;
            margin-bottom: $padding;
            color: $f_sec_color;
        }

        .chart-30 {
            padding: $padding;
            background-color: $bg_sec_color;
            margin-top: $padding;
            border-radius: .5rem;

            .chart {
                height: 20rem;
            }
        }

        .top10 {
            padding: $padding;
            display: flex;
            background-color: $bg_sec_color;
            margin-top: $padding;
            border-radius: .5rem;

            .top10-chart {
                height: 20rem;
                flex: 1;

            }
        }

        .style {
            padding: $padding;
            display: flex;
            background-color: $bg_sec_color;
            margin-top: $padding;
            border-radius: .5rem;

            .top10-chart {
                height: 15rem;
                flex: 1;

            }
        }

        .seg {
            height: $padding;
            width: 100%;
        }

        .seg-width {
            width: $padding;
            height: 100%;
        }
    }
}
</style>
  